import React, {Component} from "react";
import "./NewContribution.scss";
import {Scrollbars} from "react-custom-scrollbars";
import moment from "moment";
import $ from "jquery"
import {Empty, Tooltip, message} from "antd";
import BaseComponent from "../../../../base/BaseComponent";

class NewContribution extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            dataSource: []
        };
    }

    componentDidMount() {
        if (process.env.REACT_APP_NAME === 'pms') {
            this.getLatest_test()
        }

    }

    render() {
        const {dataSource} = this.state;
        let icon = {
            1: 'images/icon-pc.png',
            2: 'images/icon-wechat.png',
            3: 'images/icon-wb.png',
            5: 'images/douyin_icon.png',
            10: 'images/rong-mei.png',
            6: 'images/pictureIcon.png',
        };
        return (
            <div className="StaticMyDeskItemPaddingTop">
                <div id="NewContribution" style={{borderRadius: '5px', height: 300}}>
                    <div className="new_c_header" style={{
                        borderTopLeftRadius: '5px',
                        borderTopRightRadius: '5px',
                        color: '#000',
                        lineHeight: '45px',
                        height:' 45px',
                        fontSize: '16px'
                    }}>
                        最新发稿
                    </div>
                    <Scrollbars autoHide style={{height: '250px'}}>
                        <div className="new_c_list"
                             style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                            {
                                dataSource && dataSource.length ?
                                    (
                                        dataSource.map((item, index) => {
                                            return (
                                                <div className="new_c_list_item" key={index}>
                                                    <Tooltip placement={"topLeft"} overlayStyle={{maxWidth:500}} title={item.title ? item.title : ''}>
                                                        <div className="item_title" style={{
                                                            overflow: 'hidden',
                                                            whiteSpace: 'nowrap',
                                                            textOverflow: 'ellipsis'
                                                        }} onClick={() => {
                                                            console.log(item);
                                                            this.currentClick(item);
                                                        }}>{item.title ? item.title : ''}</div>
                                                    </Tooltip>
                                                    <div className="item_info">
                                                        <img className="item_info_icon"
                                                             src={item.mediaLogo ? item.mediaLogo : ""} alt=""/>
                                                        <div
                                                            title={item.mediaName ? item.mediaName : '稿件'}
                                                            className="item_info_origin">{item.mediaName ? item.mediaName : '稿件'}</div>
                                                        <div>{moment(item.publishDate).startOf('mm').fromNow()}</div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    ) : <Empty style={{marginTop: '80px'}}/>
                            }
                        </div>
                        <style>{`
                        .new_c_list .ant-empty-image{
                        height: 80px !important;
                        }
                        `}</style>
                    </Scrollbars>
                </div>
            </div>
        );
    }

    getLatest_test() {
        let url = `/cm-sites-pms/index/lastPublish`;
        this.request({
            url, callBack: (res) => {
                // console.log("2222222222222", res);
                let dataSource = [];
                if (res && res.length) {
                    dataSource = res;
                    this.setState({dataSource: dataSource})
                }
            }
        })
    }

    // 查看发布
    viewRelease(item, url, params) {
        console.log('................', item);
        this.request({
            url: url,
            body: params,
            callBack: (res) => {
                console.log(res);
                if (res) {
                    switch (item.mediaTypeCode) {
                        case 'webNews':
                            window.open(res[0].linkUrl);
                            break;
                        case 'material':
                            // window.open(res.linkUrl ? res.linkUrl : message.error('查看失败！'));
                            window.open(res.linkUrl);
                            break;
                        case 'douyin':
                            window.open(res.linkUrl);
                            break;
                        case 'weibo':
                            window.open(res.linkUrl);
                            break;
                        case 'kuaishou':
                            window.open(res.playUrl);
                            break;
                    }
                }
            }
        })
    }

    currentClick(item) {
        let mediaTypeCode = item.mediaTypeCode;
        let url = '';
        let params;
        switch (mediaTypeCode) {
            case 'webNews':
                url = '/cm-sites-pms/website/news/getPublishUrl';
                params = {webNewsId: item.entityId};
                break;
            case 'material':
                // url = '/cm-sites-pms/material/getMaterial';
                params = {id: item.entityId};
                break;
            case 'douyin':
                url = '/cm-sites-pms/douyin/getPublishUrl';
                params = {id: item.entityId};
                break;
            case 'weibo':
                url = '/cm-sites-pms/weibo/getPublishUrl';
                params = {id: item.entityId};
                break;
            case 'kuaishou':
                url = '/cm-sites-pms/kuaishou/getById';
                params = {id: item.entityId};
                break;
        }
        if(url){
            this.viewRelease(item, url, params);
        }
    }
}

export default NewContribution;

